import { afterNextRender, Injector } from '@angular/core';

/**
 * This function facilitates waiting for signals to finish and react to the next stable render of components in an
 * asynchronize way using Promises.
 *
 * @param injector injected Injector of component.
 * @param fun optional asynchronize function to be called after all signals and corresponding effects finished.
 */
export function waitForNextRender(injector: Injector, fun?: () => Promise<unknown>): Promise<void> {
  return new Promise(resolve => {
    afterNextRender(
      async () => {
        if (fun) {
          await fun();
        }

        return resolve();
      },
      { injector },
    );
  });
}
